import { API_ROOT_URL } from '..'
import { FormValues } from '../../app/systemStatus/formChangeSystemStatus'

import { client } from '../moovyAxiosClient'
import { SystemStatusDTO } from './dto'

const BASE_URL = `${API_ROOT_URL}/site`

const getSiteDetails = async () => {
  return client.get(`${BASE_URL}`)
}

const changeSystemStatus = async (values: FormValues) => {
  const body: SystemStatusDTO = {
    isEnabled: values.action === 'ENABLE',
    reason: values.comment,
  }
  return client.put(`${BASE_URL}/system-status`, body)
}

export const SiteDetailsApi = {
  getSiteDetails,
  changeSystemStatus,
}
